// extracted by mini-css-extract-plugin
export default {"addButton":"SearchModalWidnow_addButton__5amVU","wrapperFilter":"SearchModalWidnow_wrapperFilter__uTSqQ"};